export default function FutureSection() {
  const benefits = [
    {
      icon: 'ri-walk-line',
      title: '痛みを気にせず動ける',
      description: '朝起きた時の痛みや、動き始めの違和感が減り、身体が軽くなっていきます。'
    },
    {
      icon: 'ri-emotion-happy-line',
      title: '毎日が楽しくなる',
      description: '痛みに振り回されず、やりたいことに集中できる毎日を取り戻せます。'
    },
    {
      icon: 'ri-heart-3-line',
      title: '前向きな気持ちになれる',
      description: '身体が整うと、気持ちも前向きに。「良くなっている」実感が自信につながります。'
    },
    {
      icon: 'ri-time-line',
      title: '将来への不安が減る',
      description: '痛みが戻りにくい身体になることで、この先もずっと元気でいられる安心感が生まれます。'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#F0FDF4] to-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#10B981]/5 rounded-full -ml-48 -mt-48"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#10B981]/5 rounded-full -mr-48 -mb-48"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <span className="px-5 py-2 bg-[#10B981] text-white text-sm font-medium rounded-full">
              Your Future
            </span>
          </div>
          <h2 className="text-5xl font-bold text-[#065F46] mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            こんな未来が待っています
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            痛みから解放されると、<br className="hidden md:block" />
            こんなふうに変わっていきます
          </p>
        </div>

        {/* Featured Image */}
        <div className="max-w-4xl mx-auto mb-16 rounded-3xl overflow-hidden w-full h-[520px] md:h-[640px]">
          <img
            src="https://storage.readdy-site.link/project_files/dd63e7f2-2ad5-4550-918c-a85f51c054ca/0568c1c7-f42f-4765-9f82-9c9dfdecc06e_IMG_8650.png?v=0fa9165302a87b51ae64220e42ae3682"
            alt="施術後の理想的な状態・こんな未来が待っています"
            className="w-full h-full object-cover object-center"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto mb-16">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 border border-[#D1FAE5]"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#10B981] to-[#059669] rounded-2xl mb-6">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#065F46] mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                {benefit.title}
              </h3>
              <p className="text-base text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#10B981] to-[#059669] rounded-3xl p-12 text-center shadow-2xl max-w-4xl mx-auto">
          <p className="text-2xl text-white font-bold mb-6" style={{ fontFamily: "'Noto Serif JP', serif", lineHeight: '1.8' }}>
            「もう良くならない」と諦めていた方も、<br className="hidden md:block" />
            身体は必ず変わります。
          </p>
          <p className="text-lg text-white/90 leading-relaxed mb-8">
            まずはLINEでお気軽にご相談ください。<br className="hidden md:block" />
            あなたの身体の悩み、一緒に解決していきましょう。
          </p>
          <a 
            href="https://lin.ee/uGMpYkR"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-[#10B981] px-10 py-5 rounded-full text-lg font-bold hover:bg-gray-50 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-2xl"></i>
            LINEで気軽に相談する
          </a>
        </div>
      </div>
    </section>
  );
}